import React, { Component } from 'react';

import AuthService from './AuthService';
import constants from '../config';
import { PAYPAL_PAYOUTS_ENABLED } from '../config/constants';
import { resolveCardImage } from '../utils/resolveImage';

const Auth = new AuthService();

var BRAND_ICONS = {
  'visa': 'fa-cc-visa',
  'Visa': 'fa-cc-visa',
  'mastercard': 'fa-cc-mastercard',
  'MasterCard': 'fa-cc-mastercard',
  'amex': 'fa-cc-amex',
  'American Express': 'fa-cc-amex',
  'discover': 'fa-cc-discover',
  'Discover': 'fa-cc-discover',
  'jcb': 'fa-cc-jcb',
  'JCB': 'fa-cc-jcb',
  'diners': 'fa-cc-diners-club',
  'Diners Club': 'fa-cc-diners-club',
};

function formatBrand(brand) {
  if (!brand) return 'Card';
  return brand.charAt(0).toUpperCase() + brand.slice(1);
}

class PaymentSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      stripeAccountId: null,
      paypalEmail: '',
      paypalSaved: false,
      // Multi-card
      cards: [],
      defaultId: null,
      cardsLoading: true,
      // Legacy single card
      savedCard: null,
      // General
      loading: true,
      confirmModal: null,
      // Payout history
      payoutSummary: null,
      payoutHistory: [],
      payoutLoading: true,
      payoutPage: 1,
      payoutTotalCount: 0,
      retrying: false,
      // Marketer wallet
      marketerBalance: 0,
      marketerWithdrawable: 0,
      marketerWithdrawalFee: 0.25,
      marketerLoading: true,
      withdrawing: false,
      withdrawMethod: 'stripe',
    };
    this.profile = this.profile.bind(this);
    this.enablePayments = this.enablePayments.bind(this);
    this.toStripe = this.toStripe.bind(this);
    this.enablePaypal = this.enablePaypal.bind(this);
    this.disconnectStripe = this.disconnectStripe.bind(this);
    this.disconnectPaypal = this.disconnectPaypal.bind(this);
    this.retryPayouts = this.retryPayouts.bind(this);
    this.retryMarketerPayouts = this.retryMarketerPayouts.bind(this);
  }

  componentDidMount() {
    this.profile(this.props.user._id);
    this.fetchPaymentMethods();
    this.handleStripeQueryParams();
    this.handlePaypalQueryParams();
    this.fetchPayoutSummary();
    this.fetchMarketerBalance();
  }

  handleStripeQueryParams() {
    var params = new URLSearchParams(window.location.search);
    var stripeStatus = params.get('stripe');
    if (stripeStatus === 'success') {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Stripe connected successfully!', type: 'success' } }));
      this.profile(this.props.user._id);
      // Auto-retry any unclaimed payouts now that Stripe is connected
      var self = this;
      setTimeout(function() { self.retryPayouts(); }, 1500);
    } else if (stripeStatus === 'incomplete') {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Stripe onboarding was not completed. Please try again.', type: 'warning' } }));
    } else if (stripeStatus === 'error') {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Something went wrong with Stripe setup.', type: 'error' } }));
    }
    if (stripeStatus) {
      params.delete('stripe');
      var stripeRemaining = params.toString();
      var stripeNewUrl = window.location.pathname + (stripeRemaining ? '?' + stripeRemaining : '');
      window.history.replaceState({}, document.title, stripeNewUrl);
    }
  }

  handlePaypalQueryParams() {
    var params = new URLSearchParams(window.location.search);
    var paypalStatus = params.get('paypal');
    if (paypalStatus === 'success') {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'PayPal connected successfully!', type: 'success' } }));
      this.profile(this.props.user._id);
      var self = this;
      setTimeout(function() { self.retryPayouts(); }, 1500);
    } else if (paypalStatus === 'error') {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Something went wrong with PayPal setup.', type: 'error' } }));
    }
    if (paypalStatus) {
      // Strip paypal param but keep other params (like tab=payments)
      params.delete('paypal');
      var remaining = params.toString();
      var newUrl = window.location.pathname + (remaining ? '?' + remaining : '');
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  profile(userId) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/' + userId, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      var hasStripe = !!res.profile.stripeAccountId;
      var hasPaypal = !!(res.profile.paypalEmail);
      self.setState({
        id: userId,
        stripeAccountId: res.profile.stripeAccountId,
        paypalEmail: res.profile.paypalEmail || '',
        paypalSaved: hasPaypal,
        loading: false,
        withdrawMethod: hasStripe ? 'stripe' : (hasPaypal ? 'paypal' : 'stripe'),
      });
    }).catch(function(err) {
      console.log(err);
      self.setState({ loading: false });
    });
  }

  fetchPaymentMethods() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/payment-methods', {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      self.setState({
        cards: res.cards || [],
        defaultId: res.defaultId || null,
        cardsLoading: false,
      });
    }).catch(function(err) {
      console.log(err);
      self.setState({ cardsLoading: false });
    });
  }

  fetchPayoutSummary(page) {
    var self = this;
    var p = page || 1;
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/payout-summary?page=' + p + '&limit=10', {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      self.setState({
        payoutSummary: res.summary,
        payoutHistory: p === 1 ? res.history : self.state.payoutHistory.concat(res.history),
        payoutTotalCount: res.totalCount,
        payoutPage: p,
        payoutLoading: false,
      });
    }).catch(function(err) {
      console.log(err);
      self.setState({ payoutLoading: false });
    });
  }

  retryPayouts() {
    var self = this;
    self.setState({ retrying: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/retry-payouts', {
      mode: 'cors',
      method: 'POST',
    }).then(function(res) {
      self.setState({ retrying: false });
      if (res.retried > 0) {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: res.retried + ' payout' + (res.retried !== 1 ? 's' : '') + ' claimed successfully!', type: 'success' } }));
        self.fetchPayoutSummary();
      } else if (res.errors && res.errors.length > 0) {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Some payouts could not be processed. Please try again later.', type: 'warning' } }));
      } else {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'No unclaimed payouts to process.', type: 'info' } }));
      }
    }).catch(function(err) {
      self.setState({ retrying: false });
      var msg = 'Failed to claim payouts';
      if (err && typeof err === 'object' && err.error) msg = err.error;
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: msg, type: 'error' } }));
    });
    // Also retry any deferred marketer commissions
    this.retryMarketerPayouts();
  }

  retryMarketerPayouts() {
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/retry-marketer-payouts', {
      mode: 'cors',
      method: 'POST',
    }).then(function(res) {
      if (res.retried > 0) {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: res.retried + ' commission' + (res.retried !== 1 ? 's' : '') + ' claimed successfully!', type: 'success' } }));
      }
    }).catch(function() {
      // Silent — seller retry toast already shown
    });
  }

  fetchMarketerBalance() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/marketer-balance', {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      self.setState({
        marketerBalance: res.balance || 0,
        marketerWithdrawable: res.withdrawable || 0,
        marketerWithdrawalFee: res.withdrawalFee || 0.25,
        marketerLoading: false,
      });
    }).catch(function() {
      self.setState({ marketerLoading: false });
    });
  }

  withdrawMarketerBalance() {
    var self = this;
    var methodLabel = self.state.withdrawMethod === 'paypal' ? 'PayPal' : 'Stripe';
    self.setState({
      confirmModal: {
        title: 'Withdraw Commission',
        message: 'Withdraw $' + self.state.marketerWithdrawable.toFixed(2) + ' to your ' + methodLabel + ' account? A $' + self.state.marketerWithdrawalFee.toFixed(2) + ' withdrawal fee will be deducted from your $' + self.state.marketerBalance.toFixed(2) + ' balance.',
        confirmLabel: 'Withdraw via ' + methodLabel,
        confirmColor: '#c9a84c',
        onConfirm: function() {
          self.setState({ confirmModal: null, withdrawing: true });
          Auth.fetch(constants.DOMAIN + '/api/v1/transactions/marketer-withdraw', {
            mode: 'cors',
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ payoutMethod: self.state.withdrawMethod }),
          }).then(function(res) {
            self.setState({ withdrawing: false, marketerBalance: 0, marketerWithdrawable: 0 });
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Withdrawn $' + (res.amount || 0).toFixed(2) + ' via ' + (res.method || 'payout') + '!', type: 'success' } }));
          }).catch(function(err) {
            self.setState({ withdrawing: false });
            var msg = 'Withdrawal failed';
            if (err && typeof err === 'object' && err.error) msg = err.error;
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: msg, type: 'error' } }));
          });
        },
      },
    });
  }

  enablePayments() {
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/authorize', {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      window.location.assign(res);
    }).catch(function(err) {
      console.log(err);
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to enable Stripe', type: 'error' } }));
    });
  }

  toStripe() {
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/dashboard', {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      window.open(res.url);
    }).catch(function(err) {
      console.log(err);
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to open Stripe dashboard', type: 'error' } }));
    });
  }

  disconnectStripe() {
    var self = this;
    self.setState({
      confirmModal: {
        title: 'Disconnect Stripe',
        message: 'Are you sure you want to disconnect your Stripe account? You will not be able to receive payments until you reconnect.',
        confirmLabel: 'Disconnect',
        onConfirm: function() {
          self.setState({ confirmModal: null });
          Auth.fetch(constants.DOMAIN + '/api/v1/transactions/disconnect-stripe', {
            mode: 'cors',
            method: 'POST',
          }).then(function() {
            self.setState({ stripeAccountId: null });
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Stripe disconnected', type: 'success' } }));
          }).catch(function(err) {
            console.log(err);
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to disconnect Stripe', type: 'error' } }));
          });
        },
      },
    });
  }

  enablePaypal() {
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/paypal/authorize', {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      window.location.assign(res);
    }).catch(function(err) {
      console.log(err);
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to start PayPal setup', type: 'error' } }));
    });
  }

  disconnectPaypal() {
    var self = this;
    self.setState({
      confirmModal: {
        title: 'Disconnect PayPal',
        message: 'Are you sure you want to disconnect your PayPal account? You will not be able to receive PayPal payments until you reconnect.',
        confirmLabel: 'Disconnect',
        onConfirm: function() {
          self.setState({ confirmModal: null });
          Auth.fetch(constants.DOMAIN + '/api/v1/transactions/disconnect-paypal', {
            mode: 'cors',
            method: 'POST',
          }).then(function() {
            self.setState({ paypalEmail: '', paypalSaved: false });
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'PayPal disconnected', type: 'success' } }));
          }).catch(function(err) {
            console.log(err);
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to disconnect PayPal', type: 'error' } }));
          });
        },
      },
    });
  }

  removeCard(cardId) {
    var self = this;
    self.setState({
      confirmModal: {
        title: 'Remove Card',
        message: 'Remove this payment card? You will need to re-enter card details on your next purchase.',
        confirmLabel: 'Remove',
        onConfirm: function() {
          self.setState({ confirmModal: null });
          Auth.fetch(constants.DOMAIN + '/api/v1/transactions/payment-methods/' + cardId, {
            mode: 'cors',
            method: 'DELETE',
          }).then(function() {
            self.fetchPaymentMethods();
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Card removed', type: 'success' } }));
          }).catch(function(err) {
            console.log(err);
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to remove card', type: 'error' } }));
          });
        },
      },
    });
  }

  setDefault(cardId) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/payment-methods/default', {
      mode: 'cors',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ paymentMethodId: cardId }),
    }).then(function() {
      self.fetchPaymentMethods();
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Default card updated', type: 'success' } }));
    }).catch(function(err) {
      console.log(err);
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to set default card', type: 'error' } }));
    });
  }

  render() {
    var self = this;
    var cardClass = 'tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-p-6 tw-mb-6';
    var cardStyle = { border: '1px solid #e0e0e0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };
    var inputClass = 'tw-w-full tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f] tw-rounded-xl tw-px-5 tw-py-3 tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] focus:tw-border-brand-gold tw-outline-none tw-text-[#111] dark:tw-text-white tw-transition-colors';
    var labelClass = 'tw-block tw-text-sm tw-font-medium tw-text-[#555] dark:tw-text-[#aaa] tw-mb-2';
    var btnClass = 'tw-px-8 tw-py-3 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors';
    var cards = this.state.cards;
    var isSeller = this.state.stripeAccountId || this.state.paypalSaved;
    var summary = this.state.payoutSummary;

    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-12">
          <div className="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
        </div>
      );
    }

    return (
      <div>
        {/* Saved Payment Methods */}
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Payment Methods</h3>

          {this.state.cardsLoading ? (
            <div className="tw-flex tw-items-center tw-justify-center tw-py-6">
              <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
            </div>
          ) : cards.length > 0 ? (
            <div className="tw-space-y-3">
              {cards.map(function(card) {
                return (
                  <div key={card.id} className="tw-flex tw-items-center tw-gap-4 tw-p-4 tw-rounded-lg tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f]">
                    <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-white dark:tw-bg-[#1a1a1a] tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ border: '1px solid #e0e0e0' }}>
                      <i className={'fa ' + (BRAND_ICONS[card.brand] || 'fa-credit-card') + ' tw-text-xl tw-text-[#555] dark:tw-text-[#aaa]'}></i>
                    </div>
                    <div className="tw-flex-1">
                      <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">
                        {formatBrand(card.brand)} ending in {card.last4}
                        {card.isDefault ? (
                          <span className="tw-ml-2 tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-bg-brand-gold/10 tw-text-brand-gold">Default</span>
                        ) : null}
                      </p>
                      <p className="tw-text-xs tw-text-[#888] tw-mt-0.5">Expires {card.expMonth}/{card.expYear}</p>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-2">
                      {!card.isDefault ? (
                        <button
                          onClick={function() { self.setDefault(card.id); }}
                          className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-border tw-border-brand-gold tw-text-brand-gold tw-bg-transparent tw-cursor-pointer hover:tw-bg-brand-gold/10 tw-transition-colors"
                        >
                          Set Default
                        </button>
                      ) : null}
                      <button
                        onClick={function() { self.removeCard(card.id); }}
                        className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-border-none tw-bg-transparent tw-cursor-pointer tw-transition-colors"
                        style={{ color: '#dc2626' }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="tw-flex tw-items-center tw-gap-4 tw-mb-4">
              <div className="tw-w-12 tw-h-12 tw-rounded-xl tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f] tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                <i className="fa fa-credit-card tw-text-2xl tw-text-[#555] dark:tw-text-[#aaa]"></i>
              </div>
              <div>
                <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">No saved cards</p>
                <p className="tw-text-xs tw-text-[#888] tw-mt-1">Your card will be saved on your next purchase</p>
              </div>
            </div>
          )}
        </div>

        {/* Stripe */}
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Stripe Payments</h3>
          <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6">
            <div className="tw-w-12 tw-h-12 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: 'rgba(99,91,255,0.1)' }}>
              <i className="fa fa-cc-stripe tw-text-2xl" style={{ color: '#635bff' }}></i>
            </div>
            <div className="tw-flex-1">
              <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">Stripe Connect</p>
              {this.state.stripeAccountId !== null ? (
                <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-green-600/10 tw-text-green-600 tw-mt-1">
                  <i className="fa fa-check-circle tw-mr-1"></i>Connected
                </span>
              ) : (
                <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-[#f5f5f5] dark:tw-bg-[#333] tw-text-[#888] tw-mt-1">
                  Not Connected
                </span>
              )}
            </div>
          </div>
          {this.state.stripeAccountId !== null ? (
            <div className="tw-flex tw-items-center tw-gap-4">
              <button onClick={this.toStripe} className={btnClass}>
                <i className="fa fa-external-link tw-mr-2"></i>View Stripe Dashboard
              </button>
              <button
                onClick={this.disconnectStripe}
                className="tw-px-4 tw-py-3 tw-rounded-lg tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-sm tw-font-medium tw-transition-colors"
                style={{ color: '#dc2626' }}
              >
                Disconnect
              </button>
            </div>
          ) : (
            <button onClick={this.enablePayments} className={btnClass}>
              <i className="fa fa-plus tw-mr-2"></i>Enable Stripe Payments
            </button>
          )}
        </div>

        {/* PayPal — hidden when PayPal payouts are disabled */}
        {PAYPAL_PAYOUTS_ENABLED && (
          <div className={cardClass} style={cardStyle}>
            <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">PayPal</h3>
            <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6">
              <div className="tw-w-12 tw-h-12 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: 'rgba(0,48,135,0.1)' }}>
                <i className="fa fa-paypal tw-text-2xl" style={{ color: '#003087' }}></i>
              </div>
              <div className="tw-flex-1">
                <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">PayPal Account</p>
                {this.state.paypalSaved ? (
                  <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-green-600/10 tw-text-green-600 tw-mt-1">
                    <i className="fa fa-check-circle tw-mr-1"></i>Connected
                  </span>
                ) : (
                  <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-[#f5f5f5] dark:tw-bg-[#333] tw-text-[#888] tw-mt-1">
                    Not Connected
                  </span>
                )}
              </div>
            </div>
            {this.state.paypalSaved ? (
              <div>
                <p className="tw-text-sm tw-text-[#111] dark:tw-text-white tw-mb-4">
                  <i className="fa fa-check-circle tw-mr-1.5" style={{ color: '#22c55e' }}></i>
                  {this.state.paypalEmail}
                </p>
                <button
                  onClick={this.disconnectPaypal}
                  className="tw-px-4 tw-py-3 tw-rounded-lg tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-sm tw-font-medium tw-transition-colors"
                  style={{ color: '#dc2626' }}
                >
                  Disconnect
                </button>
              </div>
            ) : (
              <button onClick={this.enablePaypal} className={btnClass}>
                <i className="fa fa-paypal tw-mr-2"></i>Connect PayPal
              </button>
            )}
          </div>
        )}

        {/* Payout History */}
        {isSeller ? (
          <div className={cardClass} style={cardStyle}>
            <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Earnings & Payouts</h3>

            {this.state.payoutLoading ? (
              <div className="tw-flex tw-items-center tw-justify-center tw-py-6">
                <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
              </div>
            ) : summary ? (
              <div>
                {/* Unclaimed Payouts Callout */}
                {summary.unclaimed > 0 ? (
                  <div className="tw-mb-6 tw-p-4 tw-rounded-xl tw-flex tw-items-center tw-justify-between tw-gap-3 tw-flex-wrap" style={{ backgroundColor: 'rgba(249,115,22,0.1)', border: '1px solid rgba(249,115,22,0.3)' }}>
                    <div className="tw-flex tw-items-start tw-gap-3">
                      <i className="fa fa-exclamation-circle tw-text-xl tw-text-orange-500" style={{ marginTop: 2 }}></i>
                      <div>
                        <p className="tw-text-sm tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-0">
                          ${summary.unclaimed.toFixed(2)} in unclaimed payouts
                        </p>
                        <p className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-mb-0">
                          {self.state.stripeAccountId || self.state.paypalSaved
                            ? 'Click to claim your earnings now.'
                            : PAYPAL_PAYOUTS_ENABLED
                              ? 'Connect a payout method above to claim your earnings.'
                              : 'Connect Stripe above to claim your earnings.'}
                        </p>
                      </div>
                    </div>
                    {(self.state.stripeAccountId || self.state.paypalSaved) ? (
                      <button
                        onClick={self.retryPayouts}
                        disabled={self.state.retrying}
                        className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-none tw-cursor-pointer tw-transition-colors tw-text-white disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
                        style={{ backgroundColor: '#f97316' }}
                      >
                        {self.state.retrying ? (
                          <span className="tw-inline-flex tw-items-center"><i className="fa fa-spinner fa-spin tw-mr-1.5"></i>Processing...</span>
                        ) : (
                          <span className="tw-inline-flex tw-items-center"><i className="fa fa-money tw-mr-1.5"></i>Claim All Payouts</span>
                        )}
                      </button>
                    ) : null}
                  </div>
                ) : null}

                {/* Summary Cards */}
                <div className="tw-grid tw-grid-cols-2 tw-gap-3 tw-mb-6">
                  <div className="tw-p-4 tw-rounded-lg" style={{ backgroundColor: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)' }}>
                    <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-1">Total Earned</p>
                    <p className="tw-text-xl tw-font-bold" style={{ color: '#c9a84c' }}>${summary.totalEarned.toFixed(2)}</p>
                  </div>
                  <div className="tw-p-4 tw-rounded-lg" style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.2)' }}>
                    <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-1">Released</p>
                    <p className="tw-text-xl tw-font-bold tw-text-green-600">${summary.released.toFixed(2)}</p>
                  </div>
                  <div className="tw-p-4 tw-rounded-lg" style={{ backgroundColor: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)' }}>
                    <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-1">Pending</p>
                    <p className="tw-text-xl tw-font-bold" style={{ color: '#f59e0b' }}>${summary.held.toFixed(2)}</p>
                  </div>
                  <div className="tw-p-4 tw-rounded-lg" style={{ backgroundColor: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)' }}>
                    <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-1">Disputed</p>
                    <p className="tw-text-xl tw-font-bold tw-text-red-500">${summary.disputed.toFixed(2)}</p>
                  </div>
                  {summary.unclaimed > 0 ? (
                    <div className="tw-p-4 tw-rounded-lg tw-col-span-2" style={{ backgroundColor: 'rgba(249,115,22,0.08)', border: '1px solid rgba(249,115,22,0.2)' }}>
                      <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-1">Unclaimed</p>
                      <p className="tw-text-xl tw-font-bold tw-text-orange-500">${summary.unclaimed.toFixed(2)}</p>
                    </div>
                  ) : null}
                </div>

                {/* History Table */}
                {this.state.payoutHistory.length > 0 ? (
                  <div>
                    <h4 className="tw-text-sm tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-3">Transaction History</h4>
                    <div className="tw-space-y-2">
                      {this.state.payoutHistory.map(function(item) {
                        var statusColors = {
                          released: { bg: 'rgba(34,197,94,0.1)', text: '#22c55e' },
                          held: { bg: 'rgba(245,158,11,0.1)', text: '#f59e0b' },
                          disputed: { bg: 'rgba(239,68,68,0.1)', text: '#ef4444' },
                          refunded: { bg: 'rgba(156,163,175,0.1)', text: '#9ca3af' },
                          payout_failed: { bg: 'rgba(249,115,22,0.1)', text: '#f97316' },
                        };
                        var statusLabels = {
                          released: 'Released', held: 'Held', disputed: 'Disputed', refunded: 'Refunded', payout_failed: 'Unclaimed',
                        };
                        var sc = statusColors[item.status] || statusColors.held;
                        return (
                          <div key={item._id} className="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-lg tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f]">
                            {item.postImage ? (
                              <img
                                src={resolveCardImage(item.postImage)}
                                alt=""
                                className="tw-w-10 tw-h-10 tw-rounded-lg tw-object-cover tw-flex-shrink-0"
                              />
                            ) : (
                              <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-[#e0e0e0] dark:tw-bg-[#333] tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                                <i className="fa fa-image tw-text-[#888]"></i>
                              </div>
                            )}
                            <div className="tw-flex-1 tw-min-w-0">
                              <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white tw-truncate">{item.postTitle}</p>
                              <p className="tw-text-xs tw-text-[#888]">{new Date(item.date).toLocaleDateString()}</p>
                            </div>
                            <div className="tw-text-right tw-flex-shrink-0">
                              <p className="tw-text-sm tw-font-semibold tw-text-[#111] dark:tw-text-white">${item.amount.toFixed(2)}</p>
                              <span
                                className="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium"
                                style={{ backgroundColor: sc.bg, color: sc.text }}
                              >
                                {statusLabels[item.status] || item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {this.state.payoutHistory.length < this.state.payoutTotalCount ? (
                      <button
                        onClick={function() { self.fetchPayoutSummary(self.state.payoutPage + 1); }}
                        className="tw-w-full tw-mt-3 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-text-brand-gold tw-bg-transparent tw-border tw-border-brand-gold tw-cursor-pointer hover:tw-bg-brand-gold/10 tw-transition-colors"
                      >
                        Show More
                      </button>
                    ) : null}
                  </div>
                ) : (
                  <p className="tw-text-sm tw-text-[#888] tw-text-center tw-py-4">No transactions yet.</p>
                )}
              </div>
            ) : (
              <p className="tw-text-sm tw-text-[#888] tw-text-center tw-py-4">No earnings yet. Start selling to see your payout history.</p>
            )}
          </div>
        ) : null}

        {/* Commission Wallet */}
        {!this.state.marketerLoading ? (
          <div className={cardClass} style={cardStyle}>
            <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">
              <i className="fa fa-share-alt tw-mr-2" style={{ color: '#c9a84c' }}></i>Share & Earn Commissions
            </h3>
            <div className="tw-grid tw-grid-cols-2 tw-gap-3 tw-mb-6">
              <div className="tw-p-4 tw-rounded-lg" style={{ backgroundColor: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)' }}>
                <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-1">Commission Balance</p>
                <p className="tw-text-2xl tw-font-bold" style={{ color: '#c9a84c' }}>${this.state.marketerBalance.toFixed(2)}</p>
              </div>
              <div className="tw-p-4 tw-rounded-lg" style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.2)' }}>
                <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-1">Available to Withdraw</p>
                <p className="tw-text-2xl tw-font-bold tw-text-green-600">${this.state.marketerWithdrawable.toFixed(2)}</p>
              </div>
            </div>
            <p className="tw-text-xs tw-text-[#888] tw-mb-4">
              A ${this.state.marketerWithdrawalFee.toFixed(2)} withdrawal fee applies per withdrawal.
            </p>
            {/* PayPal withdraw option — hidden when PayPal payouts are disabled */}
            {PAYPAL_PAYOUTS_ENABLED && this.state.stripeAccountId && this.state.paypalSaved ? (
              <div className="tw-mb-4">
                <p className="tw-text-xs tw-font-medium tw-text-[#888] tw-mb-2">Withdraw to:</p>
                <div className="tw-flex tw-gap-2">
                  <button
                    onClick={function() { self.setState({ withdrawMethod: 'stripe' }); }}
                    className={'tw-flex tw-items-center tw-gap-1.5 tw-px-4 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border tw-cursor-pointer tw-transition-colors'}
                    style={self.state.withdrawMethod === 'stripe' ? { backgroundColor: 'rgba(99,91,255,0.1)', borderColor: '#635bff', color: '#635bff' } : { backgroundColor: 'transparent', borderColor: '#555', color: '#888' }}
                  >
                    <i className="fa fa-credit-card"></i>Stripe
                  </button>
                  <button
                    onClick={function() { self.setState({ withdrawMethod: 'paypal' }); }}
                    className={'tw-flex tw-items-center tw-gap-1.5 tw-px-4 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border tw-cursor-pointer tw-transition-colors'}
                    style={self.state.withdrawMethod === 'paypal' ? { backgroundColor: 'rgba(0,112,187,0.1)', borderColor: '#0070ba', color: '#0070ba' } : { backgroundColor: 'transparent', borderColor: '#555', color: '#888' }}
                  >
                    <i className="fa fa-paypal"></i>PayPal
                  </button>
                </div>
              </div>
            ) : null}
            <button
              onClick={function() { self.withdrawMarketerBalance(); }}
              disabled={this.state.withdrawing || this.state.marketerWithdrawable <= 0}
              className="tw-px-8 tw-py-3 tw-rounded-lg tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              style={{ backgroundColor: '#c9a84c' }}
            >
              {this.state.withdrawing ? (
                <span className="tw-inline-flex tw-items-center"><i className="fa fa-spinner fa-spin tw-mr-1.5"></i>Withdrawing...</span>
              ) : (
                <span className="tw-inline-flex tw-items-center"><i className="fa fa-money tw-mr-1.5"></i>Withdraw ${this.state.marketerWithdrawable.toFixed(2)}</span>
              )}
            </button>
            {!this.state.stripeAccountId && !this.state.paypalSaved ? (
              <p className="tw-text-xs tw-mt-3 tw-mb-0" style={{ color: '#f97316' }}>
                <i className="fa fa-exclamation-triangle tw-mr-1"></i>
                {PAYPAL_PAYOUTS_ENABLED
                  ? 'Connect Stripe or PayPal above to withdraw your commissions.'
                  : 'Connect Stripe above to withdraw your commissions.'}
              </p>
            ) : null}
          </div>
        ) : null}

        {/* Confirm Modal */}
        {this.state.confirmModal ? (
          <div
            className="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50"
            onClick={function(e) { if (e.target === e.currentTarget) self.setState({ confirmModal: null }); }}
          >
            <div className="tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-p-6 tw-w-full tw-max-w-sm tw-mx-4" style={{ border: '1px solid #e0e0e0' }}>
              <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-3">
                {this.state.confirmModal.title}
              </h3>
              <p className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa] tw-mb-6">
                {this.state.confirmModal.message}
              </p>
              <div className="tw-flex tw-justify-end tw-gap-3">
                <button
                  onClick={function() { self.setState({ confirmModal: null }); }}
                  className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-colors tw-border-none tw-bg-[#f5f5f5] dark:tw-bg-[#333] tw-text-[#555] dark:tw-text-[#aaa]"
                >
                  Cancel
                </button>
                <button
                  onClick={this.state.confirmModal.onConfirm}
                  className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-cursor-pointer tw-transition-colors tw-border-none tw-text-white"
                  style={{ backgroundColor: this.state.confirmModal.confirmColor || '#dc2626' }}
                >
                  {this.state.confirmModal.confirmLabel}
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default PaymentSettings;
